import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHeader, CtaBand } from "../components/site/Sections";
import { Reveal, MaskLines } from "../components/site/Reveal";
import { ServiceIcon } from "../components/site/ServiceIcon";
import { Seo } from "../components/site/Seo";
import { SERVICES } from "../data/site";

const STEPS = [
  ["Listen", "We ask a lot of questions. Some slightly annoying. All of them useful."],
  ["Plan", "A clear, prioritised plan with goals you can measure. One page, not fifty."],
  ["Launch", "We make the thing and ship it. Quickly, and properly."],
  ["Grow", "We read the numbers, keep what works, fix what doesn't. Repeat."],
];

export default function Services() {
  return (
    <>
      <Seo path="/services" title="Marketing services" description="Marketing strategy, content creation, SEO, social media, email marketing and paid advertising for Canberra businesses." />
      <PageHeader eyebrow="Services" lines={["Marketing that", "pulls its weight."]}
        intro="Pick one, combine a few, or let us tell you which ones you don't need. Every engagement starts with a clear goal and ends with results you can see." />
      <section className="wrap pb-20 sm:pb-28">
        <div className="grid gap-px overflow-hidden rounded-[1.75rem] border border-ink/10 bg-ink/10 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 0.08} className="h-full bg-canvas">
              <Link to={`/services/${s.slug}`} className="group flex h-full flex-col p-8 transition-colors duration-500 hover:bg-white sm:p-10" data-testid={`service-card-${s.slug}`}>
                <div className="flex items-center justify-between">
                  <span className="grid h-12 w-12 place-items-center rounded-2xl bg-ink text-canvas transition-colors duration-500 group-hover:bg-flame"><ServiceIcon name={s.icon} /></span>
                  <span className="font-display text-sm font-semibold text-ink/40">0{i + 1}</span>
                </div>
                <h2 className="mt-12 font-display text-3xl font-bold tracking-tight text-ink">{s.title}</h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/70 md:text-base">{s.short}</p>
                <span className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-ink">
                  See how it works <ArrowUpRight className="h-4 w-4 text-flame transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="bg-white py-20 sm:py-28">
        <div className="wrap">
          <Reveal><span className="eyebrow">How it works</span></Reveal>
          <MaskLines as="h2" onLoad={false} lines={["Four steps.", "Zero guesswork."]} className="h2 mt-5" />
          <ol className="mt-14 grid gap-8 md:grid-cols-4">
            {STEPS.map(([t, d], i) => (
              <Reveal as="li" key={t} delay={i * 0.08} className="border-t-2 border-ink pt-6">
                <span className="font-display text-sm font-semibold text-flame">Step 0{i + 1}</span>
                <h3 className="mt-3 font-display text-2xl font-semibold text-ink">{t}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/70">{d}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>
      <div className="pt-20 sm:pt-28"><CtaBand /></div>
    </>
  );
}
